import BeeImage from '../../images/games/k2reveal/bee.png';
import TigerImage from '../../images/games/k2reveal/tiger.png';
import BridgeImage from '../../images/games/k2reveal/bridge.png';
import BikeImage from '../../images/games/k2reveal/bike.png';
import CamelImage from '../../images/games/k2reveal/camel.png';
import CraneImage from '../../images/games/k2reveal/crane.png';
import DogImage from '../../images/games/k2reveal/dog.png';
import PillarImage from '../../images/games/k2reveal/pillar.png';
import GoatImage from '../../images/games/k2reveal/goat.png';
import HouseImage from '../../images/games/k2reveal/house.png';

var revOrder = ["#picBR", "#picBL", "#picTR", "#picTL"];
var rNet = 1;

var imageMapping = {
  'A': BeeImage,
  'B': TigerImage,
  'C': BridgeImage,
  'D': BikeImage,
  'E': CamelImage,
  'F': CraneImage,
  'G': DogImage,
  'H': PillarImage,
  'I': GoatImage,
  'J': HouseImage
}

function setImageDimensions(dimensions) {
  $('#picContainer').css('width', dimensions[0]);
  $('#picContainer').css('height', dimensions[1]);
};

function getImageDimensions(image_src, callback) {
  var image = new Image();
  image.src = image_src;
  image.onload = function() { callback(this.width, this.height); }
};

function setBoxes() {
  $('.picCorner').css('width', getImageDimensions[0] / 2);
  $('.picRow').css('height', getImageDimensions[1] / 2);
};

function changeGamePicture(letter) {
  $('#pickGameContainer').addClass('d-none');
  $('#gameContainer').removeClass('d-none');
  $('.btn-back').addClass('d-none');
  $('.btn-refresh').removeClass('d-none');
  $('#picContainer').css("background-image", 'url(' + imageMapping[letter] + ')');
  var checkExist = setInterval(function() {
   if ($('#picContainer').length) {
      clearInterval(checkExist);
      getImageDimensions( imageMapping[letter],
        function(width, height) {
          setImageDimensions([width, height])
        }
      );
      $('#picContainer').removeClass('d-none');
    }
  }, 100); // check every 100ms
}

jQuery(function() {
  $('#gamek2reveal').on('click', ".imgAll", function() {
	  changeGamePicture(this.textContent)
	})

  $('#gamek2reveal').on('click', "#picContainer", function() {
    $(revOrder[0]).fadeTo(1000, 0);
    $("#choiceCont").css("opacity","1");
    $("#click").css("opacity","0");
    $("input").val("");
  });

  $('#gamek2reveal').on('click', "#choiceSubmit", function() {
    $(revOrder[rNet]).fadeTo(1000, 0);

    var newGuess = $("#input").serialize().replace("input=",'').replace(/%20/g, " ");
    if(rNet == 1){
      $("#rg1").text(newGuess);
      $("#input").val("");
      $("#choiceTitle").text("What has changed in your thinking?");
    } else if(rNet == 2){
      $("#guess2").text("Second Thought:");
      $("#rg2").text(newGuess);
      $("#input").val("");
      $("#choiceTitle").text("What new thoughts are you having about this image?");
    } else if(rNet == 3){
      $("#guess3").text("Third Thought:");
      $("#rg3").text(newGuess);
      $("#input").val("");
      $("#choiceTitle").text("How is your first thought different from your last thought?");
      $("#input").hide();
      $("#choiceSubmit").hide();
      $("#choiceNext").css("opacity", "1");
    }
    rNet++;
  })
})
